<template>
  
  <div id="udhr_rights_selector_wrapper" class="position-relative">
    
    <div class="brown-bg d-flex flex-column pb-4">
    
    <button class="prev btn-reset" @click="previous()">
        <SVGArrow role="button" class="btn-close-arrow"></SVGArrow>
        <span class="sr-only">Previous</span>
    </button>

    <button class="next btn-reset" @click="next()">
        <SVGArrow role="button" class="btn-close-arrow"></SVGArrow>
        <span class="sr-only">Next</span>
    </button>
        <div class="container pt-2 px-0 mt-5">

            <div id="rights_slider_wrapper" class="position-relative">
                <flickity v-if="items" id="flickity_container" ref="flickity" @init="onFlickityInit" :options="flickityOptions">
                    <div v-for="i in items" :key="i.id" class="carousel-cell">
                        <div class="row">
                            <div class="col-12 col-sm-4 img-column d-flex justify-content-end pl-sm-5 pl-xl-0 mb-3">
                                <div class="square">
                                    <div class="content" @click="selected = true">
                                        <DraggableRight
                                            :key="'article_' + i.id" 
                                            :imgSrc="i.illustration.url_resized_square"
                                            :title="$t(iKey('related_udhr_articles', i, 'title'))"
                                            :label="$t(iKey('related_udhr_articles', i, 'label'))"
                                            :alt="$t(iKey('related_udhr_articles', i, 'illustration_desc'))"
                                            @dropped="onDropped"
                                            @clicked="onClicked"
                                            >
                                        </DraggableRight>
                                        <cite class="vertical d-inline">{{ $t(iKey('related_udhr_articles', i, 'illustration_caption')) }}</cite>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-column col-sm-8 px-4 px-lg-5">
                                <span class="guide-text2 d-inline-block mt-0 mt-lg-3 my-0 my-lg-3">{{ $t(iKey('related_udhr_articles', i, 'label')) }}</span>
                                <h5>{{ $t(iKey('related_udhr_articles', i, 'title')) }}</h5>
                                <p class="description secondary">{{ $t(iKey('related_udhr_articles', i, 'description')) }}</p> 
                            </div>  
                        </div> 
                    </div>
                </flickity>

               

            </div>

            <div ref="dropzones_wrapper" id="dropzones_wrapper" class="">
                
                <div class="d-flex justify-content-center">
                    <div role="group" class="dropzones d-flex justify-content-between my-3">
                        <DropzoneRight class="dzone" id="udhr_dz_1" :num="1" :imgObj="dropzones.udhr_dz_1"></DropzoneRight>
                        <DropzoneRight id="udhr_dz_2" :num="2" :imgObj="dropzones.udhr_dz_2"></DropzoneRight>
                        <DropzoneRight id="udhr_dz_3" :num="3" :imgObj="dropzones.udhr_dz_3"></DropzoneRight>
                    </div>
                </div>
                
            </div>
            <div class="text-center mb-5"><a href="#" v-on:click.prevent="randomize" class="guide-text2 pointer randomize">{{ $t(iKey('issue_selection_section', 'issue_selection', 'help_text')) }}</a></div>
           
        </div>
        <CtaCircle 
            aria-hidden="true"
            id="udhr_next" 
            :appear="dropzones.dropCount > 2"
            :label="$t(iKey('issue_selection_section', 'issue_selection', 'cta_next'))"
            :color="'968c82'">
        </CtaCircle>
    </div>
    
  </div>
  
</template>
<script>

import Flickity from 'vue-flickity';
import DraggableRight from '@/components/udhr/DraggableRight';
import DropzoneRight from '@/components/udhr/DropzoneRight';
import CtaCircle from '@/components/ui/CtaCircle';
import SVGArrow from '@/assets/icons/arrow-skinny.svg';


export default {
  name: 'UDHR',
  components: {
      Flickity,
      DraggableRight,
      DropzoneRight,
      CtaCircle,
      SVGArrow
  },
  data() {
    return {
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        adaptiveHeight: true,
        lazyLoad: true
      },
      dropzones: {
        dropCount: 0,
        udhr_dz_1: {
            imgSrc: "",
            label: "",
            title: "",
            alt: "",
        },
        udhr_dz_2: {
            imgSrc: "",
            label: "",
            title: "",
            alt: ""
        },
        udhr_dz_3: {
            imgSrc: "",
            label: "",
            title: "",
            alt: ""
        }
      }
    }
  },
  props: [
    'items'
  ],
  methods: {
    onFlickityInit(){
        let flickViewport = document.getElementsByClassName('flickity-viewport')[0];
        flickViewport.appendChild(this.$refs.dropzones_wrapper);
    },
    next() {
      this.$refs.flickity.next();
    },
    previous() {
      this.$refs.flickity.previous();
    },
    onDropped(dropzone, imgSrc, label, title, alt){ 
        this.populateDropzone(dropzone, imgSrc, label, title, alt)
    },
    onClicked(imgSrc, label, title, alt){
        // select next empty dropzone and populate
        for(let i=1; i <= 3; i++){
            if(!this.$data.dropzones['udhr_dz_' + i].imgSrc){
                this.populateDropzone('udhr_dz_' + i, imgSrc, label, title, alt)
                break;
            }
        }
    },
    randomize(){
        var arr = []
        this.$props.items.forEach(function(o){ arr.push(o) })
        var shuffled = arr.sort(() => 0.5 - Math.random());
        var selected = shuffled.slice(0, 3);
        for(var i=1; i<=selected.length; i++){
            this.populateDropzone(
                'udhr_dz_' + i, 
                selected[i - 1].illustration.url_resized_square,
                this.$t(this.$parent.iKey('related_udhr_articles', selected[i - 1], 'label')),
                this.$t(this.$parent.iKey('related_udhr_articles', selected[i - 1], 'title')),
                this.$t(this.$parent.iKey('related_udhr_articles', selected[i - 1], 'illustration_desc'))
                )
        }
    },
    populateDropzone(dropzoneIndex, imgSrc, label, title, alt){
        this.$data.dropzones[dropzoneIndex].imgSrc = imgSrc;
        this.$data.dropzones[dropzoneIndex].label = label;
        this.$data.dropzones[dropzoneIndex].title = title;
        this.$data.dropzones[dropzoneIndex].alt = alt;
        this.$data.dropzones.dropCount += 1;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    h5 {
        font-size: 20px;
        line-height: 1.4em;
    }
    .description.secondary {
        font-size: 14px;
        line-height: 1.4em;
    }
    @media (min-width: 768px) { 
        h5 {
            font-size: 24px;
        }
        .description.secondary {
            font-size: 16px;
        }
    }
    @media (min-width: 992px) { 
        h5 {
            font-size: 32px;
        }
        .description.secondary {
            font-size: 18px;
            line-height: 30px;
        }
    }
    
    @media (max-width: 575px) { 
        #rights_slider_wrapper .xs-full {
            max-width: 100% !important;
            flex: 0 0 100% !important;
        }

         #rights_slider_wrapper .img-column {
             padding-left: 80px;
             padding-right: 80px;
         }
    }
    .text-column {
        padding-bottom: 140px;
    }
    @media (min-width: 667px) { 
        .text-column {
            padding-bottom: 160px;
        }
    }
    @media (min-width: 768px) { 
        .text-column,
        .img-column {
            padding-bottom: 195px;
        }
    }
    @media (min-width: 1024px) { 
        .text-column,
        .img-column {
            padding-bottom: 255px;
        }
    }
     @media (min-width: 1367px) { 
         .img-column {
             padding-bottom: 260px;
         }
     }

    .container {
        width: 75%;
    }
    .brown-bg {
        background: url(../../assets/images/brown-bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        color: white;
    }
   
    .highlight {
        background-color: #00b0a8; 
        padding: 5px 15px;
        display: inline-block;
    }
    .randomize {
        color: #968c82;
        transition: color 0.2s;
        text-decoration: underline;
    }
    .randomize:hover {
        color: #00b0a8;
    }
    #dropzones_wrapper {
        position: absolute;
        bottom: 0;
        z-index: 0;
        width: 100%;
        pointer-events: none;
        padding-bottom: 30px;
    }
    @media(min-width: 768px){
        #dropzones_wrapper {
            margin-left: 25px;
            padding-bottom: 60px;
        }
    }
    #dropzones_wrapper .dropzones {
        width: 85%;
    }

    #dropzones_wrapper .dropzones .dzone-wrap{
        width: 33%;
    }
    
    .flickity-viewport {
        pointer-events: none;
    }
    .carousel-cell {
        width: 100%;
    }
  
    @media (min-width: 1020px) and (min-height: 1300px){
        .description {
            display: inline !important;
        }
    } 
    .square {
        top: 10px;
        left: 10px;
        position: relative;
        width: 100%;
    }
    @media (min-width: 992px) { 
        .square {
            width: 85%;
            top: 20px;
            left: 20px;
        }
    }
    .square:after{
        content: "";
        display: block;
        padding-bottom: 100%;
    }
    .square .content {
        position:absolute;
        width: 100%;
        height: 100%;
        right: 10px;
        top: -10px;
    }
    @media (min-width: 576px){
        .square:after{
            background-color: #2f2523;
            right: 20px;
            top: -20px;
        }
    }
   
    
    cite {
        color: #968c82;
    }
    cite.vertical {
        position: absolute;
        left: -25px;
        top: 0px;
        writing-mode: vertical-rl;
        margin: 0;
        padding: 0;
        color: #968c82;
        font-size: 10px;
    }
    @media (min-width: 768px){
        cite.vertical {
            font-size: 12px;
        }
    }

    button.prev,
    button.next {
        top: 20vh;
        position: absolute;
        width: 40px;
        height: 40px;
    }
    button.prev {
        left: 0px;
        transform: rotate(-180deg);
    }
    button.next {
        right: 0px;
    }
    button svg g {
        stroke: white;
    }
    @media(min-width: 578px){
        button.prev,
        button.next {
            width: 50px;
            height: 50px;
        }
    }
    @media(min-width: 768px){
        button.prev {
            left: 50px;
        }
        button.next {
           right: 50px;
        }
    }
    @media(min-width: 992px){
        button.prev {
            left: 80px;
        }
        button.next {
           right: 80px;
        }
    }
   
    #udhr_next {
        position: absolute;
        bottom: -100px;
        right: -60px;
    }
    .pointer {
        pointer-events: auto;
    }
    
   
</style>

<style>
    .flickity-slider {
        z-index: 1;
        pointer-events: none;
    }
    .flickity-viewport {
        transition: height 0.3s ease;
    }
</style>